import JSEncrypt from 'jsencrypt/bin/jsencrypt'

// 密钥对生成 http://web.chacuo.net/netrsakeypair

const publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDP+xalGwmS1KlvMVBIY3N+WPT0\n' + 
    'MlyH8HoG8sEoC1DLnjfV1H388WfdXHHut1UBZWlGhI13A50ZzfoRjiMnNIvpy7bK\n' +
    '3J103E0s3POnk1+o59fT9f4rTIHvvedpXKohPPvTpqHKuX6uLzHI2l84hVvTqXmz\n' +
    '4JnZC4z+1OdYCyMFswIDAQAB'

// 加密
export function encrypt(txt) {
  const encryptor = new JSEncrypt()
  encryptor.setPublicKey(publicKey) // 设置公钥
  return encryptor.encrypt(txt) // 对需要加密的数据进行加密
}





// WEBPACK FOOTER //
// ./src/utils/rsaEncrypt.js